import { useEffect, useRef } from 'react'
import { useResizeObserver } from 'usehooks-ts'
import { sendFrameMessage } from '../utils/frame'

export function useSyncFrameSize (): void {
  const ref = useRef<HTMLElement>(document.body)
  useResizeObserver({
    ref,
    box: 'border-box',
    onResize: ({ height }) => {
      if (height !== undefined) {
        sendFrameMessage({ type: 'resize', height })
      }
    }
  })

  useEffect(() => {
    sendFrameMessage({ type: 'resize', height: document.body.scrollHeight })
  }, [])
}
